import {
  ActivitiesSVGs,
  AvailabilitySVGs,
  BlogSVGs,
  BookingSVGs,
  EarningSVGs,
  LogoutSVGs,
  MessageSVGs,
  SessionSVGs,
  SettingSVGs,
  ClientsSVGs,
  WalletSVGs,
  ScheduleSVGs,
  PaymentSVGs,
} from "./SVGs";
import { IoIosPeople } from "react-icons/io";
import { FaMoneyBills, FaUserTie } from "react-icons/fa6";
import { MdDashboard } from "react-icons/md";

import { FaWallet, FaUser, FaHeadset } from "react-icons/fa";
import { AiOutlineSchedule } from "react-icons/ai";

// Menu data
export const coachMenu = [
  {
    category: "Account & Setup",
    icon: "setup",
    items: [
      {
        label: "Dashboard",
        icon: "dashboard",
        path: "/coach/dashboard",
        matchPaths: ["/coach/dashboard", "/coach/dashboard/accounts", "/coach/dashboard/setup"],
        component: <MdDashboard className="w-[18px] h-[18px]" />,
      },
      // {
      //   label: "Coaching Workspace",
      //   icon: "workspace",
      //   path: "/coach/coachingworkspace",
      //   matchPaths: ["/coach/coachingworkspace"],
      //   component: <MdDashboard className="w-[18px] h-[18px]" />,
      // },
      {
        label: "My Profile",
        icon: "my-profile",
        path: "/coach/profile",
        component: <FaUserTie className="w-[18px] h-[18px]" />,
      },
    ]
  },
  {
    category: "Programs & Sessions",
    icon: "sessions",
    items: [
      {
        label: "My Programs",
        icon: "sessions",
        path: "/coach/sessions",
        matchPaths: ["/coach/sessions", "/coach/createProgram"],
        component: <SessionSVGs />,
      },
      {
        label: "Availability",
        icon: "availability",
        path: "/coach/availability",
        matchPaths: ["/coach/availability"],
        component: <AvailabilitySVGs />,
      },
      {
        label: "Schedules",
        icon: "booking",
        path: "/coach/booking",
        matchPaths: ["/coach/booking"],
        component: <BookingSVGs />,
      },
    ]
  },
  {
    category: "Communication",
    icon: "clients",
    items: [
      {
        label: "My Clients",
        icon: "clients",
        path: "/coach/clients",
        matchPaths: ["/coach/clients"],
        component: <ClientsSVGs />,
      },
      {
        label: "Messages",
        messageCount: 4,
        icon: "messages",
        path: "/coach/messages",
        matchPaths: ["/coach/messages"],
        notification: true,
        component: <MessageSVGs />,
      },
    ]
  },
  {
    category: "Content",
    icon: "content",
    items: [
      {
        label: "My Activities",
        icon: "activities",
        path: "/coach/my-activities",
        matchPaths: ["/coach/my-activities"],
        component: <img src="/myactivitiescoach.svg" alt="Activities" className="w-[18px] h-[18px]" />,
        subItems: [
          { label: "Posts", path: "/coach/my-activities?active=social_feeds" },
          { label: "Shorts", path: "/coach/my-activities?active=short_video" },
          { label: "Free Sessions", path: "/coach/my-activities?active=free_live_session" },
        ]
      },
      {
        label: "My Blogs",
        icon: "blogs",
        path: "/coach/my-blogs",
        matchPaths: ["/coach/my-blogs"],
        component: <BlogSVGs />,
      },
    ]
  },
  {
    category: "Business",
    icon: "business",
    items: [
      {
        label: "My Earnings",
        icon: "earnings",
        path: "/coach/earnings",
        matchPaths: ["/coach/earnings", "/coach/payout", "/coach/bank-payout"],
        component: <EarningSVGs />,
      },
      {
        label: "My Subscription",
        icon: "Subscription",
        path: "/coach/Subscription",
        matchPaths: ["/coach/Subscription"],
        component: <img src="/coachnewsub.svg" alt="Subscription" className="w-[18px] h-[18px]" />,
      },
    ]
  },
  {
    category: "System",
    icon: "system",
    items: [
      {
        label: "Settings",
        icon: "setting",
        path: "/coach/setting",
        matchPaths: ["/coach/setting"],
        component: <img src="/usersetting.svg" alt="Settings" className="w-[18px] h-[18px]" />,
      },
      {
        label: "Support",
        icon: "support",
        path: "/coach/support-listing",
        matchPaths: ["/coach/support-listing"],
        component: <img src="/coachsupport.svg" alt="Support" className="w-[18px] h-[18px]" />,
      },
    ]
  }
];

// User menu categorized
export const userMenu = [
  {
    category: "Account & Setup",
    icon: "account",
    items: [
      {
        label: "Dashboard",
        icon: "dashboard",
        path: "/user/dashboard",
        matchPaths: ["/user/dashboard"],
        component: <MdDashboard className="w-[18px] h-[18px]" />,
      },
      {
        label: "Dashboard 2",
        icon: "dashboard2",
        path: "/user/dashboard2",
        matchPaths: ["/user/dashboard2"],
        component: <MdDashboard className="w-[18px] h-[18px]" />,
      },

      {
        label: "My Profile",
        icon: "my-profile",
        path: "/user/profile",
        component: <img src="/usernewprofile.svg" alt="My Profile" className="w-[18px] h-[18px]" />,
      },
      // {
      //   label: "Coaching Interests",
      //   icon: "interests",
      //   path: "/user/profile",
      //   component: <img src="/usercoachinginterest.svg" alt="Coaching Interests" className="w-[18px] h-[18px]" />,
      // },
    ]
  },
  {
    category: "Programs & Sessions",
    icon: "sessions",
    items: [
      {
        label: "My Programs",
        icon: "Programme",
        path: "/user/upcoming-session",
        matchPaths: ["/user/upcoming-session", "/user/createProgram"],
        component: <img src="/usermyprogram.svg" alt="My Programs" className="w-[18px] h-[18px]" />,
      },
      {
        label: "My Schedules",
        icon: "schedules",
        path: "/user/my-programs",
        matchPaths: ["/user/my-programs"],
        component: <img src="/usermysessionsschedules.svg" alt="My Sessions Schedules" className="w-[18px] h-[18px]" />,
      },
    ]
  },
  {
    category: "Communication",
    icon: "communication",
    items: [
      {
        label: "Messages",
        messageCount: 4,
        icon: "messages",
        path: "/user/messages",
        matchPaths: ["/user/messages"],
        notification: true,
        component: <img src="/usermessages.svg" alt="My Programs" className="w-[18px] h-[18px]" />,
      },
      {
        label: "My Coaches",
        icon: "coaches",
        path: "/user/my-coach",
        matchPaths: ["/user/my-coach"],
        component: <img src="/usermyprogram.svg" alt="My Programs" className="w-[18px] h-[18px]" />,
      },
    ]
  },
  {
    category: "My Coaches Feed",
    icon: "feed",
    items: [
      {
        label: "My Activity",
        icon: "activity",
        path: "/user/activities",
        matchPaths: ["/user/activities"],
        component: <img src="/myactivitiescoach.svg" alt="Activities" className="w-[18px] h-[18px]" />,
        subItems: [
          { label: "Posts", path: "/user/activities?active=social_feeds" },
          { label: "Short Videos", path: "/user/activities?active=short_video" },
          { label: "Free Live Sessions", path: "/user/activities?active=free_live_session" },
        ]
      },
    ]
  },
  {
    category: "Payments",
    icon: "payments",
    items: [
      {
        label: "Payment History",
        icon: "payments",
        path: "/user/payment-history",
        matchPaths: ["/user/payment-history"],
        component: <img src="/userpaymenthistroy.svg" alt="Support" className="w-[18px] h-[18px]" />,
      },
      // {
      //   label: "Invoices",
      //   icon: "invoices",
      //   path: "/user/payment-history",
      // component: <img src="/coachsupport.svg" alt="Support" className="w-[18px] h-[18px]" />,
      // },
    ]
  },
  {
    category: "System",
    icon: "system",
    items: [
      {
        label: "Setting",
        icon: "setting",
        path: "/user/setting",
        matchPaths: ["/user/setting"],
        component: <img src="/usersetting.svg" alt="Settings" className="w-[18px] h-[18px]" />,
      },
      {
        label: "Support",
        icon: "support",
        path: "/user/support-listing",
        matchPaths: ["/user/support-listing"],
        component: <img src="/coachsupport.svg" alt="Support" className="w-[18px] h-[18px]" />,
      },
    ]
  },
];
